import {IPropertyTypeConfig} from '@mintdata/mint-kit/api/properties/PropertyTypeConfig';
import {APositiveNumber} from '@mintdata/mint-kit/api/values/APositiveNumber';
import {APositiveNumberConverter} from '@mintdata/mint-kit/impl/properties/converters/APositiveNumberConverter';
import {APositiveNumberEditor} from '@mintdata/mint-kit/impl/properties/editors/APositiveNumberEditor';

export const APositiveNumberConfig:IPropertyTypeConfig<APositiveNumber> =
    {
        converter: APositiveNumberConverter,
        editor: APositiveNumberEditor,
    };
